import { render, staticRenderFns } from "./SimpleWeeklySchedulePost.vue?vue&type=template&id=5f90c540&scoped=true"
import script from "./SimpleWeeklySchedulePost.vue?vue&type=script&lang=js"
export * from "./SimpleWeeklySchedulePost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f90c540",
  null
  
)

export default component.exports